import React, { useState, useEffect } from "react";
import { Container, Col, Row, Table, Button, Card, Form } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import 'react-voice-recorder/dist/index.css';
import { apiUrl } from "../commons/inFormTypes";
import Loaders from "../components/Loaders";
import Map from "../components/Map";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoaderBtn from "../components/LoaderBtn";
// import RecordField,CheckboxField from "../components/Fields";
import RecordField, {
  CheckboxField, DateField, ImagesField, MultiselectField,
  NumberField, RadioField, SectionFields, TextField
} from "../components/Fields";
import { MultiStepForm, Step } from 'react-multi-form';


function Service(props) {
  const [validated, setValidated] = useState(false)
  const [isValid, setIsValid] = useState(false);
  const [idForm, setIdForm] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);
  const [code, setCode] = useState();
  const [showLocation, setShowLocation] = useState('');
  const [result, setResult] = useState()
  const [address, setAddress] = useState("");
  const [listLocations, setListLocations] = useState([]);
  const [search, setSearch] = useState(false);
  const [active, setActive] = useState(1);
  const [visibilities, setVisibilities] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [snip, setSnip] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const [recordnum, setRecordnum] = useState([]);
  const [seenFileData, setSeenFileData] = useState("");
  const [subSelect, setSubSelect] = useState([]);
  const [subSelectX, setSubSelectX] = useState(false);
  const [parentList, setParentList] = useState([]);
  let [lat, setLat] = useState('');
  let [log, setLog] = useState('');
  let [searchClicked, setSearchClicked] = useState(false);
  const userToken = localStorage.getItem("user_token");
  const userName = localStorage.getItem("user_namefamily")
  const navigate = useNavigate();
  let { requestId } = useParams();
  const axios = require("axios");


  //get all of field data
  useEffect(() => {
    if (userToken === null) {
      navigate("/");
    } else {
      setloaded(false)
      var data = new FormData();
      data.append("id", requestId);
      axios({
        method: "get",
        url: apiUrl + "service/" + requestId,
        headers: {
          'Access-Control-Allow-Origin': "*",
          Accept: "application/json",
          Authorization: "Bearer " + userToken,
          // ...data.getHeaders()
        },
        data: data,
      }).then((res) => {
        let count = Math.ceil(res.data.result.form_fields.length / 3);//Calculate the count of step
        for (let j = 0; j < count; j++) {
          recordnum.push({
            step: `مرحله-${j + 1}`
          })
        }
        setloaded(true);
        /////////////////for set subselect????????????????????????
        let old = subSelect;
        for (let i = 0; i < res.data.result.form_fields.length; i++) {

          if (res.data.result.form_fields[i].type === "map") {
            setLat(res.data.result.form_fields[i].values[0].value);
            setLog(res.data.result.form_fields[i].values[1].value);
          }
          old[res.data.result.form_fields[i].name] = res.data.result.form_fields[i].values ? res.data.result.form_fields[i].values : [];
          setSubSelect(old);

          if (res.data.result.form_fields[i].required === true) {
            setIdForm(oldArray => [...oldArray, res.data.result.form_fields[i].name + '/' + Math.ceil((i + 1) / 3)]);
            // console.log("idddd",res.data.result.form_fields[i].name)
          }
        }
        var l = parentList
        setParentList(l)
        setSeenFileData(res.data.result)
        setSeenFile(res.data.result.form_fields);
        console.log(res.data.result)
      });


    }
  }, []);



  //function for address
  const addressHandler = (val) => {
    var name = val.split("_***_")[0]; //برای دسترسی به نام    
    var type = val.split("_***_")[1]; //برای دسترسی به نوع    
    var value = val.split("_***_")[2]; //برای دسترسی به مقدار    

    visibilities[name] = {
      value: value,
      type: type
    };
  }

  //function for dropdown
  const selectParentHandler = (child, val) => {
    var name = val.split("_***_")[0]; //برای دسترسی به نام    
    var type = val.split("_***_")[1]; //برای دسترسی به نوع    
    var value = val.split("_***_")[2]; //برای دسترسی به مقدار    

    visibilities[name] = {
      value: value,
      type: type
    };

    var data = new FormData();
    data.append('value', value);
    axios({
      method: "post",
      url: apiUrl + "field/data",
      headers: {
        'Access-Control-Allow-Origin': "*",
        Accept: "application/json",
        Authorization: "Bearer " + userToken,
      },
      data: data,

    }).then((res) => {
      let old = subSelect;
      old[child] = res.data.values;

      setSubSelect(old);
      setSubSelectX(subSelectX === false ? true : false);
    });
  }



  const selectHandler = (val) => {
    var name = val.split("_***_")[0]; //برای دسترسی به نام    
    var type = val.split("_***_")[1]; //برای دسترسی به نوع    
    var value = val.split("_***_")[2]; //برای دسترسی به مقدار    
    visibilities[name] = {
      value: value,
      type: type
    };
  }


  //function for regist request
  const requestHandler = () => {
    var x = false;
    const filteredItems = idForm.filter(item => item.includes('/' + active));
    Object.entries(filteredItems).forEach((s, index) => {
      if (!x) {
        if (visibilities[filteredItems[index].replace('/' + active, '')] !== undefined && (visibilities[filteredItems[index].replace('/' + active, '')].value === undefined || visibilities[filteredItems[index].replace('/' + active, '')].value === '' || visibilities[filteredItems[index].replace('/' + active, '')].value === null)) {
          toast.error("لطفا فیلدهای ستاره دار را تکمیل نمایید", {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          x = true;
        }
        if (visibilities[filteredItems[index].replace('/' + active, '')] === undefined) {
          toast.error("لطفا فیلدهای ستاره دار را تکمیل نمایید", {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          x = true;
        }
      }
    });

    if (!x) {
      var data = new FormData();
      data.append("flow_id", seenFileData.flow_id);
      data.append("form_id", seenFileData.form_id);
      data.append("refer_id", seenFileData.refer_id);
      data.append("service_id", seenFileData.service_id);
      data.append("tracking_code", seenFileData.tracking_code);

      Object.entries(visibilities).forEach(([name, item], index) => {
        data.append(name, item.value);
      });
      setSnip(true)
      axios({
        method: "post",
        url: apiUrl + "form-receive",
        headers: {
          'Access-Control-Allow-Origin': "*",
          Accept: "application/json",
          Authorization: "Bearer " + userToken,
        },
        data: data,
      }).then((res) => {
        setSnip(false)
        if (res.data.success) {
          setCode(res.data.data.tracking_code)
          toast.success("اطلاعات شما با موفقیت ثبت شد", {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setResult(true)
        }
        else {
          toast.error("لطفا اطلاعات را تکمیل نمایید", {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        // navigate(`/admin/follow/${res.data.data.tracking_code}`, { replace: false });
      })
        .catch(function (error) {
          setSnip(false)
          if (error.response) {
            toast.error(error.response.data.message, {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }


  //function for set audioHandler 
  const audioHandler = (name, audio_url) => {
    visibilities[name] = {
      type: "audio",
      value: audio_url
    };
  }

  //function for show information map 
  const mapHandler = (lat, lng,name) => {
    var data = new FormData();
    data.append("coordinates", `${lat},${lng}`);
    axios({
      method: "post",
      url: apiUrl + "reverse-geo",
      headers: {
        'Access-Control-Allow-Origin': "*",
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + userToken,
      },
      data: data,
    })
      .then((res) => {
        setAddress(res.data.result);
        visibilities[name] = {
          type: "map",
          value: `${lat},${lng}`
        };
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  //function for set image 
  const imageHandler = (img, name) => {
    visibilities[name] = {
      type: "file",
      value: img
    };
  }

  //function for set checkbox 
  const checkHandler = (val, name) => {

    visibilities[name] = {
      type: "checkbox",
      value: val
    };
  }

  //function for set radio 
  const radioHandler = (val, name) => {
    visibilities[name] = {
      type: "radio",
      value: val
    };
  }

  //function for set radio 
  const multiselectHandler = (val, name) => {

    visibilities[name] = {
      type: "multiselect",
      value: val
    };
  }

  //function for set number 
  const numberHandler = (val, name) => {
    visibilities[name] = {
      type: "number",
      value: val
    };
  }

  //function for set section 
  const sectionHandler = (val, name) => {
    visibilities[name] = {
      type: "section",
      value: val
    };
  }

  //function for set section 
  const dateHandler = (val, name) => {
    visibilities[name] = {
      type: "date",
      value: val
    };
  }

  //function for set section 
  const textHandler = (val, name) => {
    visibilities[name] = {
      type: "text",
      value: val
    };
  }

  const checkParent = (name) => {
    let result = parentList.findIndex((i) => i.name === name) >= 0;
    return result;
  }

  //search of Map
  const HandleChange = (e) => {
    setAddress(e.target.value);
    var data = new FormData();
    if (e.target.value.length > 5) {
      // Clear the previous timeout, if it exists
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Set a new timeout
      const newTimeoutId = setTimeout(() => {
        // Perform the action you want after the timeout (e.g., make an API call)
        data.append("term", address);
        axios({
          method: "post",
          url: apiUrl + "search-location",
          headers: {
            'Access-Control-Allow-Origin': "*",
            Accept: "application/json",
            Authorization: "Bearer " + userToken,
            // ...data.getHeaders()
          },
          data: data,
        })
          .then((res) => {
            //  setloaded(true);
            if (res.data) {
              if (res.data.length > 0) {
                setSearch(true);
                setListLocations(res.data);
              }
              else
                setSearch(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              toast.error("عدم ارتباط با سرور", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          });
      }, 3000); // Adjust the timeout duration as needed (e.g., 1000ms or 1 second)

      // Store the new timeout ID in state
      setTimeoutId(newTimeoutId);
      //  setloaded(false);

    } else {
      setSearch(false)
    }
  };

  const HandleSearch = (name, address1, latx, laty) => {
    setLat(latx);
    setLog(laty);
    setSearchClicked(!searchClicked);
    setAddress(address1);
    setSearch(false);

    visibilities[name] = {
      type: "map",
      value: `${latx},${laty}`
    };

  };

  const cardHandler = (Id) => {
    navigate(`/admin/follow/${Id}`, { replace: false });
  };

  const nextStepHandler = (event) => {
    const form = event.currentTarget;
    var x = false;
    const filteredItems = idForm.filter(item => item.includes('/' + active));
    Object.entries(filteredItems).forEach((s, index) => {
      if (!x) {
        if (form.checkValidity() === false && visibilities[filteredItems[index].replace('/' + active, '')] !== undefined && (visibilities[filteredItems[index].replace('/' + active, '')].value === undefined || visibilities[filteredItems[index].replace('/' + active, '')].value === '' || visibilities[filteredItems[index].replace('/' + active, '')].value === null)) {
          event.preventDefault();
          event.stopPropagation();
          x = true;

        }
        if (visibilities[filteredItems[index].replace('/' + active, '')] === undefined) {
          event.preventDefault();
          event.stopPropagation();
          x = true;
        }
      }

    });
    if (!x) 
      setActive(active + 1);
      event.preventDefault();
      setValidated(true)
  }

  return (
    <div>
      {loaded === false ?
        <Loaders loads={loaded} />
        :
        result !== true ?
          (
            <Container >

              <Row className="justify-content-center rgc-service">
                <Col xs={11} lg={10} className="text-center rgc-title">
                  <div className="rgc-msg text-end text-md-center">
                    <p>شهروند گرامی حداکثر زمان پاسخگویی به درخواست شما 30 روز می باشد</p>
                  </div>
                  <div className="d-flex rgc-title">
                    <div className="rgc-title-point"></div>
                    <h4>{seenFileData.service_title}</h4>
                  </div>
                  <Form noValidate validated={validated} onSubmit={(event) => nextStepHandler(event)}>
                    <MultiStepForm activeStep={active} >
                      {recordnum.map((Number, indx) => {
                        return (
                          <Step label={Number.step} key={indx}>
                            {seenFile.slice(indx * 3, (indx + 1) * 3).map((data, index) => {
                              return (

                                <Row className="text-end mb-3">
                                  {
                                    (() => {
                                      switch (data.type) {
                                        case "select":
                                          return (
                                            <Col xs={12}>
                                              {
                                                <Form.Group>
                                                  <Form.Label>{data.title}  {data.required === true ? <span className="rgc-require">*</span> : ""}</Form.Label>
                                                  <Form.Select
                                                    required={data.required === true ? true : false}
                                                    className="rgc-select"
                                                    value={visibilities[data.value]}
                                                    onChange= {(e) =>
                                                      data.child ?
                                                        selectParentHandler(data.child, e.target.value)
                                                        :
                                                        selectHandler(e.target.value)
                                                    }
                                                  >
                                                    <option key={0} value="">
                                                      لطفا انتخاب کنید
                                                    </option>
                                                    {subSelect && subSelect[data.name] && subSelect[data.name].map((item, index1) => {
                                                      // when the option is selected
                                                      if (item.selected) {
                                                            selectHandler(data.name + '_***_' + data.type + '_***_' + item.id);
                                                      }
                                                      return (
                                                        <option
                                                          key={index1}
                                                          value={data.name + '_***_' + data.type + '_***_' + item.id}
                                                          selected = {item.selected}
                                                        >
                                                          {item.value}
                                                        </option>
                                                    
                                                      )

                                                      
                                                    })
                                                    }
                                                  </Form.Select>
                                                  <Form.Control.Feedback type="invalid">
                                                    لطفا گزینه مورد نظر را وارد نمایید
                                                  </Form.Control.Feedback>
                                                </Form.Group>
                                              }
                                            </Col>
                                          )

                                        case "file":

                                          return (
                                            <Col xs={12}>
                                              <label> {data.title}</label>
                                              {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              <ImagesField imageHandler={imageHandler} name={data.name} />                         
                                            </Col>
                                          )

                                        case "audiorecord":

                                          return (
                                            <Col xs={12}>
                                              <label> {data.title}</label>
                                              {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              {/* ارسال تابع بازگشتی از کامپوننت
                                        Service به کاپوننت Record 
                                        در واقع نگاشت دو تابع رخ داده
                                      */}
                                              <RecordField audioHandler={audioHandler} name={data.name} />
                                              {(data.required === true && isValid === false) && <div class="text-danger fs-1">لطفا صدای خود را ثبت نمایید</div>}

                                            </Col>
                                          )

                                        case "textarea":

                                          return (
                                            <Col xs={12}>
                                              <Form.Group className="rgc-input-icons" controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>
                                                  {data.title}
                                                  {data.required === true ? <span className="rgc-require">*</span> : ""}
                                                </Form.Label>
                                                <i className="fa-solid fa-signs-post"></i>
                                                <Form.Control
                                                  as="textarea"
                                                  name={data.name}
                                                  id={data.name}
                                                  rows={3}
                                                  placeholder= {data.title}
                                                  className="rgc-profile-input"
                                                  required={data.required === true ? true : false}
                                                  onChange={(e) => addressHandler(data.name + '_***_' + data.type + '_***_' + e.target.value)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                لطفا{data.title}
                                                </Form.Control.Feedback>
                                              </Form.Group>
                                            </Col>

                                          )

                                        case "map":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <Form.Group className="mb-2 rgc-input-icons" controlId="exampleForm.ControlTextarea1">
                                                <Form.Label></Form.Label>
                                                <i className="fa-solid fa-signs-post"></i>
                                                {/* <PuffLoader color={color} loading={loading} size={45} /> */}
                                                <Form.Control
                                                  // required={data.required === true ? true : false}
                                                  as="textarea"
                                                  rows={1}
                                                   placeholder={data.title}
                                                  className="rgc-profile-input"
                                                  value={address}
                                                  onChange={(e) => HandleChange(e)}
                                                />
                                              </Form.Group>
                                              {search && (
                                                <div className="rgc-search-input">
                                                  <ul>
                                                    {listLocations.map((item, index) => (
                                                      <li
                                                        key={index}
                                                        onClick={() =>
                                                          HandleSearch(data.name, item.value, item.location.y, item.location.x)
                                                        }
                                                      >
                                                        {item.value}
                                                      </li>
                                                    ))}
                                                  </ul>
                                                </div>
                                              )}
                                              <Map lat1={lat} lng1={log} mapLoad1={active} name={data.name} mapHandler={mapHandler} />
                                            </Col>
                                          )

                                        case "text":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <TextField name={data.name} textHandler={textHandler} />
                                            </Col>
                                          )

                                        case "number":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <NumberField name={data.name} numberHandler={numberHandler} />
                                            </Col>
                                          )

                                        case "checkbox":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <CheckboxField name={data.name} Setchange={checkHandler} List={data.values} />
                                            </Col>
                                          )

                                        case "radio":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <RadioField name={data.name} radioHandler1={radioHandler} List={data.values} />
                                            </Col>
                                          )

                                        case "section":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <SectionFields name={data.name} sectionHandler1={sectionHandler} title={data.title} />
                                            </Col>
                                          )

                                        case "date":
                                          return (
                                            <Col xs={12} md={6} className="form-outline rgc-icon-date">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <DateField name={data.name} dateHandler={dateHandler} />
                                            </Col>
                                          )

                                        case "multiselect":
                                          return (
                                            <Col xs={12} className="rgc-map">
                                              <label>
                                                {data.title}
                                                {data.required === true ? <span className="rgc-require">*</span> : ""}
                                              </label>
                                              <MultiselectField name={data.name} multiselectHandler={multiselectHandler} List={data.values} />
                                            </Col>
                                          )
                                        default:
                                          return (
                                            <div></div>
                                          )
                                      }
                                    })()
                                  }
                                </Row>
                              )
                            }
                            )}
                          </Step>
                        )
                      })
                      }
                    </MultiStepForm>

                    <Col xs={12} className="rgc-group-btn text-center">
                      <Row className="justify-content-center">
                        <Col xs={5} md={3} lg={2} className="text-start">
                          <Button
                            disabled={active !== 1 ? false : true}
                            onClick={() => setActive(active - 1)}
                            className="rgc-step-btn rgc-btn-color"
                          >
                            <i className='fas fa-angle-double-right'></i>
                            <span>مرحله قبل</span>
                          </Button>
                        </Col>
                        <Col xs={5} md={3} lg={2} className="text-end">
                          {active !== recordnum.length && (
                            <Button
                              //onClick={(event) => nextStepHandler(event)}
                              className="rgc-step-btn rgc-btn-color"
                              type="submit"
                            >
                              <span>مرحله بعد</span>
                              <i className='fas fa-angle-double-left'></i>
                            </Button>
                          )}
                          {active === recordnum.length && (
                            <Button
                              type="submit"
                              className="rgc-step-btn"
                              onClick={requestHandler}
                              variant="primary"
                            >
                              <span>ثبت درخواست</span>
                              <LoaderBtn loads={snip} />
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Form>
                </Col>
              </Row>
            </Container>
          )
          :
          (
            <div>

              <Row className="justify-content-center pt-5">

                <Col xs={10} lg={4} className="rgc-title">
                  <Card className="rgc-follow-card">
                    <Card.Header className="rgc-follow-header">
                      <i class='fas fa-bell'></i>
                      <div className="rgc-txt-header">
                        کد پیگیری:&nbsp;
                      </div>
                    </Card.Header>
                    <Card.Body>

                      <Row className="justify-content-md-start justify-content-center">
                        <Col xs={10} className="rgc-follow-item">نام کاربر:&nbsp; {userName}</Col>
                        <Col xs={10} className="rgc-follow-item">کد پیگیری:&nbsp;  {code}</Col>
                      </Row>

                      <Button className="float-start rgc-follow-btn m-2"
                        onClick={() => cardHandler(code)}
                      > پیگیری </Button>
                    </Card.Body>
                  </Card>

                </Col>

              </Row>
            </div>
          )

      }
    </div>
  );
}

export default Service;

